export default "__VITE_ASSET__CQi6WsMK__"